<template>
    <nav id="nav-bar" class="d-flex">
        <h1 ref="logo" style="width: 5.625rem;">
            <router-link class="logo" :to="{ path: '/' }"></router-link>
        </h1>
        <div class="navbar-content container">
            <div class="navbar-content-left info-avatar d-flex" id="account_info">
                <div class="dropdown">
                    <div class="avatar" id="dropdownMenuButton" data-mdb-toggle="dropdown" aria-expanded="false">
                        <div class="avatar-c" :style="{ backgroundImage: `url(${user_info.avatar_url})` }"></div>
                        <span class="sub-avatar" v-if="user_info.emoji_url">
                            <img :src="user_info.emoji_url">
                        </span>
                    </div>
                    <ul class="dropdown-menu profile_actions p-0" aria-labelledby="dropdownMenuButton">
                        <li>
                            <router-link :to="{ name: 'profile' }" class="dropdown-item d-flex align-items-center">
                                <svg class="menu-image" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                {{ $t('profile') }}
                            </router-link>
                        </li>
                        <li>
                            <a class="dropdown-item d-flex justify-content-between align-items-center" href="#" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#selectLangModal">
                                <div class="d-flex">
                                    <svg class="menu-image" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M5 17H9C10.6569 17 12 18.3431 12 20V10C12 7.17157 12 5.75736 11.1213 4.87868C10.2426 4 8.82843 4 6 4H5C4.05719 4 3.58579 4 3.29289 4.29289C3 4.58579 3 5.05719 3 6V15C3 15.9428 3 16.4142 3.29289 16.7071C3.58579 17 4.05719 17 5 17Z"
                                            stroke-width="2" />
                                        <path
                                            d="M19 17H15C13.3431 17 12 18.3431 12 20V10C12 7.17157 12 5.75736 12.8787 4.87868C13.7574 4 15.1716 4 18 4H19C19.9428 4 20.4142 4 20.7071 4.29289C21 4.58579 21 5.05719 21 6V15C21 15.9428 21 16.4142 20.7071 16.7071C20.4142 17 19.9428 17 19 17Z"
                                            stroke-width="2" />
                                    </svg>
                                    <span class="menu-text">{{ $t('language') }}</span>
                                </div>

                                <img class="flag" :src="flag_url" alt="" />
                            </a>
                        </li>
                        <li>
                            <router-link v-if="!doPlacementTest" :to="{ name: 'upgrade_account' }" class="dropdown-item d-flex align-items-center">
                                <svg class="menu-image menu-fill" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M13.4374 4.27252C12.7641 3.2425 11.2359 3.24249 10.5626 4.27252L7.16316 9.47274L4.56478 8.00058C3.26302 7.26303 1.69785 8.41888 2.05047 9.85733L3.81575 17.0584C3.89523 17.3827 4.18964 17.6111 4.52808 17.6111H19.4719C19.8104 17.6111 20.1048 17.3827 20.1843 17.0584L21.9495 9.85733C22.3022 8.41887 20.737 7.26304 19.4352 8.00058L16.8368 9.47274L13.4374 4.27252ZM12.2053 5.05483C12.1092 4.90768 11.8908 4.90768 11.7947 5.05482L8.01794 10.8322C7.80654 11.1556 7.37505 11.2589 7.03666 11.0672L3.83432 9.25286C3.64835 9.1475 3.42475 9.31262 3.47513 9.51811L5.10494 16.1666H18.8951L20.5249 9.51811C20.5752 9.31262 20.3517 9.1475 20.1657 9.25286L16.9633 11.0672C16.6249 11.2589 16.1935 11.1556 15.9821 10.8322L12.2053 5.05483Z"
                                        stroke-width="0.5" />
                                    <path
                                        d="M5.16032 19.5C4.75559 19.5 4.42749 19.8234 4.42749 20.2223C4.42749 20.6211 4.75559 20.9445 5.16032 20.9445H18.8397C19.2444 20.9445 19.5725 20.6211 19.5725 20.2223C19.5725 19.8234 19.2444 19.5 18.8397 19.5H5.16032Z"
                                        stroke-width="0.5" />
                                </svg>

                                {{ $t('upgrade_account') }}
                            </router-link>
                            <a v-if="doPlacementTest" class="dropdown-item d-flex align-items-center" href="#" @click.prevent="upgradeAccount()">
                                <svg class="menu-image menu-fill" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                        d="M13.4374 4.27252C12.7641 3.2425 11.2359 3.24249 10.5626 4.27252L7.16316 9.47274L4.56478 8.00058C3.26302 7.26303 1.69785 8.41888 2.05047 9.85733L3.81575 17.0584C3.89523 17.3827 4.18964 17.6111 4.52808 17.6111H19.4719C19.8104 17.6111 20.1048 17.3827 20.1843 17.0584L21.9495 9.85733C22.3022 8.41887 20.737 7.26304 19.4352 8.00058L16.8368 9.47274L13.4374 4.27252ZM12.2053 5.05483C12.1092 4.90768 11.8908 4.90768 11.7947 5.05482L8.01794 10.8322C7.80654 11.1556 7.37505 11.2589 7.03666 11.0672L3.83432 9.25286C3.64835 9.1475 3.42475 9.31262 3.47513 9.51811L5.10494 16.1666H18.8951L20.5249 9.51811C20.5752 9.31262 20.3517 9.1475 20.1657 9.25286L16.9633 11.0672C16.6249 11.2589 16.1935 11.1556 15.9821 10.8322L12.2053 5.05483Z"
                                        stroke-width="0.5" />
                                    <path
                                        d="M5.16032 19.5C4.75559 19.5 4.42749 19.8234 4.42749 20.2223C4.42749 20.6211 4.75559 20.9445 5.16032 20.9445H18.8397C19.2444 20.9445 19.5725 20.6211 19.5725 20.2223C19.5725 19.8234 19.2444 19.5 18.8397 19.5H5.16032Z"
                                        stroke-width="0.5" />
                                </svg>

                                {{ $t('upgrade_account') }}
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item d-flex justify-content-between align-items-center" href="#">
                                <label class="menu-text d-flex m-0" for="flexSwitchCheckDefault">
                                    <svg class="menu-image menu-fill" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M15 2C12.29 2 9.95 3.54 8.78 5.78C7.49615 6.44888 6.44888 7.49615 5.78 8.78C4.64119 9.37174 3.68655 10.2646 3.02005 11.3613C2.35354 12.458 2.00072 13.7166 2 15C2 18.87 5.13 22 9 22C11.71 22 14.05 20.46 15.22 18.22C16.5038 17.5511 17.5511 16.5038 18.22 15.22C19.3588 14.6283 20.3134 13.7354 20.98 12.6387C21.6465 11.542 21.9993 10.2834 22 9C22 5.13 18.87 2 15 2ZM9 20C8.07175 19.9993 7.16201 19.7402 6.37259 19.2519C5.58317 18.7636 4.9452 18.0652 4.53007 17.235C4.11495 16.4047 3.93904 15.4753 4.02203 14.5508C4.10502 13.6262 4.44364 12.743 5 12C5 15.87 8.13 19 12 19C11.16 19.63 10.12 20 9 20ZM12 17C11.0717 16.9993 10.162 16.7402 9.37259 16.2519C8.58317 15.7636 7.9452 15.0652 7.53007 14.235C7.11495 13.4047 6.93904 12.4753 7.02203 11.5508C7.10502 10.6262 7.44364 9.74305 8 9C8 12.86 11.13 15.99 15 16C14.16 16.63 13.12 17 12 17ZM16.7 13.7C16.17 13.89 15.6 14 15 14C12.24 14 10 11.76 10 9C10 8.4 10.11 7.83 10.3 7.3C10.83 7.11 11.4 7 12 7C14.76 7 17 9.24 17 12C17 12.6 16.89 13.17 16.7 13.7ZM19 12C19 8.14 15.87 5.01 12 5C12.9633 4.28166 14.1531 3.93414 15.3516 4.02098C16.5501 4.10783 17.6773 4.62325 18.527 5.47296C19.3768 6.32267 19.8922 7.44987 19.979 8.6484C20.0659 9.84693 19.7183 11.0367 19 12Z" />
                                    </svg>
                                    {{ $t('animation') }}
                                </label>
                                <div class="form-check form-switch">
                                    <input class="ito-form-check form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" :checked="animating" v-model="animating" @change="showEffect()">
                                </div>
                            </a>
                        </li>
                        <li>
                            <a class="dropdown-item d-flex align-items-center" href="#" @click.prevent="cfLogout()">
                                <svg class="menu-image" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M16 17L21 12L16 7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M21 12H9" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>

                                {{ $t('log_out') }}
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="dropdown">
                    <div class="user-name" id="dropdownMenuButton2" data-mdb-toggle="dropdown" aria-expanded="false">
                        <span class="username ">{{ user_info.fullname || user_info.username }}</span>
                        <a href="/profile" class="status warning" v-if="!user_info.email_verified || !user_info.phone_verified">
                            <i class="ito-icon-warning"></i>
                            {{ $t('account_not_verified') }}
                        </a>
                    </div>
                    <div class="dropdown-menu profile_actions_2 show" aria-labelledby="dropdownMenuButton2" v-if="(!user_info.email_verified || !user_info.phone_verified) && !dismissVerify">
                        <span @click.stop="dismissVerify = true" style="position: absolute; right: 10px; top: 5px; cursor: pointer; font-size: 20px; color: #666; z-index: 10; line-height: 1;">&times;</span>
                        <div class="d-flex flex-column justify-content-center align-items-center text-center">
                            <img src="/themes/ito/images/mascot/account_not_verify.png" alt="">
                            <p class="text-bold fs-6" v-html="$t('verify_reward_annoucement')"></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="navbar-content-right d-flex gap-3 align-items-center">
                <router-link :to="{ name: 'register' }" @click.native="getSoundClick" v-if="user_info.student_type == 2">
                    <div class="box-shadow-main d-flex gap-1 align-items-center box-info-right box-save-account">
                        <img class="icon-info-right" src="/themes/ito/images/icons/User_fill.svg">
                        <span>{{ $t('save_account') }}</span>
                    </div>
                </router-link>
                <div class="box-shadow-main d-flex gap-1 align-items-center box-info-right box-level" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#updateGradeModal" @click="clickHeaderHandler('IP1_W_1002')">
                    <img class="icon-info-right" src="/themes/ito/images/icon-league.svg">
                    <span>{{ user.grade }}</span>
                </div>
                <router-link :to="{ name: 'leaderboard' }" @click.native="clickHeaderHandler('IP1_W_1003')" v-if="user_info.account_type != 1 && user_info.student_type != 2">
                    <div class="box-shadow-main d-flex gap-1 align-items-center box-info-right box-score">
                        <img class="icon-info-right" src="/themes/ito/images/icon-chart.svg">
                        <span>{{ user_info.contest_info.id == 0 && user_info.rank != 0 ? user_info.rank : $t('rank') }}</span>
                    </div>
                </router-link>
                <div class="box-shadow-main d-flex gap-1 align-items-center box-info-right box-gem" @click="getSoundClick">
                    <AppIcon :src="$store.state.gem_icon_url" :size="21" />
                    <span>{{ $store.state.user_info.contest_info.id != 0 ? $store.state.user_info.contest_info.total_gem : user_info.gem | toCommas }}</span>

                    <div class="buy-gem" @click="gotoDailyChallenge" v-if="user_info.account_type != 1 && user_info.student_type != 2">+</div>
                    <div class="noti-alert" v-if="user_info.first_login == 1 || user_info.dailychallenge_noti != 0">
                    </div>
                </div>
                <div class="d-flex gap-1 align-items-center search-header" v-if="user_info.account_type != 1 && user_info.student_type != 2">
                    <div class="button-search" @click="handleSubmit"></div>
                    <input type="text" @keyup.enter="handleSubmit" class="search-main box-info-right box-search" :placeholder="$t('search')" autocomplete="off" v-model="search" />
                </div>
            </div>
        </div>
        <!--        <a href="/faqs" class="help-button">
            <img src="/themes/ito/images/icon-help.svg" alt="">{{$t('help')}}
        </a>-->

    </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import { getLanguage, soundClick } from "../utils/utils";
import AppIcon from "@/components/common/AppIcon.vue";

export default {
    name: "NavBar",
    components: { AppIcon },
    data() {
        return {
            user: {
                username: '',
                fullname: '',
                avatar_url: '',
                emoji_url: '',
                grade: 0,
                rank: 0,
                gem: 0,
                phone_verified: 0,
                email_verified: 0,
            },
            locate: getLanguage(),
            locate_info: null,
            localizes: null,
            search: '',
            animating: this.$store.getters.showEffect,
            dismissVerify: false,

        };
    },

    computed: {
        ...mapGetters([
            'user_info'
        ], () => {
            if (this.user_info) {
                return this.user_info
            }

            return this.user
        }),

        doPlacementTest() {
            return this.user_info.placement_test === 0 && this.user_info.student_type !== 1;
        },
        configs() {
            const conf = this.$store.state.configs
            this.locate = getLanguage();
            this.localizes = conf.localize || [];

            this.localizes.forEach(item => {
                if (item.lang == this.locate) {
                    this.locate_info = item;
                }
            });

            return this.$store.state.configs
        },
        flag_url() {
            const lang = this.$i18n.locale;
            const flag = this.configs.localize.find(item => item.lang == lang)?.img_flag;
            return flag;
        }
    },
    created() {
        this.fetch();
    },
    mounted() {
        if (this.$route.query.keyword) {
            this.search = this.$route.query.keyword;
        }
        $('#show_menu').click(function () {
            $('.dropdown__menu').toggleClass('show');
        })
    },
    methods: {
        fetch() {
            this.user.grade = localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user_info.grade;
        },
        cfLogout() {
            $('#confirmLogout').modal('show');
        },


        gotoDailyChallenge() {
            //window.location.href = '/daily-challenge';

            this.$router.push({ name: 'daily_challenge' })
        },
        clickHeaderHandler(element) {
            this.handleGACustomEvent(element)
            soundClick();
        },

        getSoundClick() {
            soundClick();

        },

        handleSubmit() {
            // const path = `/search/${this.search}`
            if (this.search == '') {
                return false;
            }
            this.$router.push({
                path: "/search",
                query: {
                    keyword: this.search,
                    t: new Date().getTime(),
                }
            });
            this.handleGACustomEvent('IP1_W_1004', this.search);
        },
        handleGACustomEvent(element, keyword) {
            const user_id = this.user_info.user_id || '';
            var params = {
                'w_user_id': user_id
            }

            if (keyword) {
                params['keyword'] = keyword
                params[element] = user_id + '|' + keyword
            } else {
                params[element] = user_id
            }
            // console.log(params);
            gtag('event', element, params)
        },
        showEffect() {
            this.$store.commit("setShowEffect", this.animating);
        },
        upgradeAccount() {
            this.$store.dispatch('setShowPlacementModalFlag', true);
        }
    }
}
</script>

<style scoped>
.user-name {
    display: flex;
    flex-direction: column;
    margin-left: 12px;
}

.user-name .username {
    font-size: 16px;
    font-weight: 700;
}

.user-name .status {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 400;
    text-decoration: underline;
    gap: 3px;
}

.user-name .status.warning {
    color: #FA450F;
}

.dropdown:hover>.dropdown-menu {
    display: block;

}

.dropdown>.dropdown-toggle:active {
    /*Without this, clicking will make it sticky*/
    pointer-events: none;
}

.profile_actions,
.profile_actions_2 {
    width: 276px;
    border-radius: 8px;
    overflow: hidden;
}

.profile_actions_2 {
    padding: 15px;
}

.profile_actions .dropdown-item {
    line-height: 26px;
    padding: 12px 30px;
}

.profile_actions .dropdown-item img {
    width: 30px;
    height: 30px;
}

.profile_actions .dropdown-item:focus,
.dropdown-item:hover {
    background: #F5F8FD;
    color: #00A3FF;
    cursor: pointer;
}

.profile_actions .dropdown-item .menu-image {
    stroke: #333333;
}

.profile_actions .dropdown-item .menu-image.menu-fill {
    fill: #333333;
}

.profile_actions .dropdown-item:focus .menu-image,
.dropdown-item:hover .menu-image {
    stroke: #00A3FF;
}

.profile_actions .dropdown-item:focus .menu-image.menu-fill,
.dropdown-item:hover .menu-image.menu-fill {
    fill: #00A3FF;
}
</style>